import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiURI, mainSite } from '../config.js';
import Bugsnag from '@bugsnag/expo';
import { PivotLogging } from './cbcLoggingSlice.js';
import { useDispatch } from 'react-redux';

const initialState = {
  loading_msg: 'idle',
  results_msg: '',
  activity_scores: [
    { name: 'Visual Memory', score: 0 },
    { name: 'Auditory Memory', score:0 },
    { name: 'Concentration', score:0 },
    { name: 'Speed', score:0 },
    { name: 'Pattern Recognition', score:0 },
    { name: 'Tracking', score:0 },
  ],
  core_focuses: [
    {
      name: 'Speed',
      img: 'https://dev.cerebrocoreusa.com/wp-content/uploads/2023/05/c3ed6eb0-a937-42eb-9b2c-00d89a74878f.png',
    },
    {
      name: 'Visual Memory',
      img: 'https://dev.cerebrocoreusa.com/wp-content/uploads/2023/05/c3ed6eb0-a937-42eb-9b2c-00d89a74878f.png',
    },
  ],
};

export const fetchLatestActivityScores = createAsyncThunk(
  'activityScores/fetchLatestActivityScores',
  async (userId, { rejectWithValue, dispatch }) => {
    Bugsnag.leaveBreadcrumb('Action fetchLatestActivityScores dispatched');
    dispatch(PivotLogging({ moduleName: 'activityScores', consoleLog: `fetchLatestActivityScores: userId=${userId}` }));
    const response = await fetch(
      `${apiURI}/get-client-workout-score-summary.php`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({ user_id: userId }),
      }
    );
    const results = await response.json();
    dispatch(PivotLogging({ moduleName: 'activityScores', consoleLog: `fetchLatestActivityScores response: ${JSON.stringify(response)}` }));
    dispatch(PivotLogging({ moduleName: 'activityScores', consoleLog: `fetchLatestActivityScores results: ${JSON.stringify(results)}` }));

    if (response.ok) {
      if (!results.success) {
        return rejectWithValue(results.msg);
      }
      return results;
    } else {
      Bugsnag.notify(
        `Api Error, get-client-workout-score-summary: ${response.text()}`
      );
      return rejectWithValue(response.text());
    }
  }
);

export const activityScoresSlice = createSlice({
  name: 'activityScores',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestActivityScores.pending, (state) => {
        state.loading_msg = 'pending';
        state.results_msg = 'Verifying You Are Logged In...';
      })
      .addCase(fetchLatestActivityScores.fulfilled, (state, { payload }) => {
        state.loading_msg = 'idle';
        state.results_msg = '';
        state.activity_scores = payload.scores.activity_scores;
        state.core_focuses = payload.scores.core_focuses;
        ////console.log("payload.scores.core_focuses: " , payload.scores.core_focuses);
      })
      .addCase(fetchLatestActivityScores.rejected, (state, { payload }) => {
        state.loading_msg = 'failed';
        state.results_msg = payload;
      });
  },
});

// extract the reducer from the slice
const { reducer } = activityScoresSlice;

// export the reducer
export default reducer;